@if (isFullyLoaded$$ | async) {
  <feedback-session
    [user]="userService.currentUser"
    [userGroup]="(selectedService.selectedSubject | async).group"
    [license]="(selectedService.selectedSubject | async).license"
    [activity]="(selectedService.selectedSubject | async).activity"
    [options]="options$$ | async"
    [session]="(selectedService.selectedSubject | async).session"
    [feedbackMode]="feedbackMode"
    [viewMode]="viewMode"
    [orgSettings]="(selectedService.selectedSubject | async).org.org_settings">
    <feedback-session-header></feedback-session-header>
  </feedback-session>
}
@if ((isFullyLoaded$$ | async) === false) {
  <div class="logo-container">
    <loading></loading>
  </div>
}
